<template>
  <div class="album bg-color__fff" v-min-height>
    <p class="tips">
      <i class="iconfont icon-tixing" />
      仅支持2M以内jpg. jpeg. gif. png格式图片上传;
      单次上传的图片数量不能超过10张
    </p>
    <div class="img-box">
      <div class="upload-img__album" v-if="!id">
        <div class="icon">
          <el-upload ref="upload" action="/" multiple :limit="10" accept=".jpg,.jpeg,.png" :on-exceed="handleExceed"
            :before-upload="_beforeLimitUpload" :file-list="fileList" :show-file-list="false" :auto-upload="false"
            :http-request="_appendFormDataInfo.bind(null, fileList)"
            :on-change="handleAddItemData.bind(null, 'fileList', _uploadImg)">
            <el-button size="36" class="iconfont  icon-tupian d5" round />
            <p>上传图片</p>
          </el-upload>
        </div>
      </div>
      <transition-group tag="ul" name="flip-list" class="img-list">
        <li class="item" v-for="(item, index) in imgList" :key="item.picId">
          <div class="relative">
            <el-image :src="item.imgUrl" class="img" :preview-src-list="imgView">
              <div slot="error" class="image-slot">
                <i class="iconfont icon-tupian" />
              </div>
            </el-image>
            <p class="operator">
              <!-- <i
                class="iconfont icon-shanchu"
                @click="delPic(item.albumId, item.picId, item.imgUrl, index)"
              /> -->
              <i class="iconfont icon-lianjie" v-clipboard:copy="item.imgUrl" v-clipboard:success="onCopy" />
              <a :href="`/u${item.imgUrl.replace(/http(s?)\S+\/u/g, '')}`" class="iconfont icon-xiazai"
                :download="item.name" />
              <i v-if="id" class="iconfont icon-shangchuan1" @click="mergePic(item)" />
            </p>
            <span class="reference" v-if="+item.state">引</span>
            <p class="name">{{ item.name }}</p>
          </div>
        </li>
      </transition-group>
    </div>
  </div>
</template>
<script>
import uploadImg from 'mixins/uploadImg'

export default {
  name: 'album',
  mixins: [uploadImg],
  inject: {
    merge: {
      from: 'picMerge'
    }
  },
  props: {
    currentNum: {
      type: Number,
      default: 1
    },
    id: {
      type: String
    }
  },
  data() {
    this.keyMap = {
      picture_list: {
        name: 'imgList',
        album_id: 'albumId',
        picture_id: 'picId',
        use_state: 'state',
        picture_name: 'name',
        url: 'imgUrl'
      }
    }
    return {
      imgList: [],
      fileList: []
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.$emit('updatePagination', 1)
    const params = {
      album_id: to.query.id,
      curpage: 1
    }
    this._getPicList(params)
    next()
  },
  created() {
    const params = {
      album_id: this.id ? this.id : this.$route.query.id,
      curpage: this.currentNum
    }
    this._getPicList(params)
  },
  computed: {
    imgView() {
      return this.imgList.map(v => {
        return v.imgUrl
      })
    }
  },
  methods: {
    /**
     * 获取图片列表
     * @param options
     */
    _getPicList(options) {
      // console.log(options)
      return this.api.getPicList(options).then(res => {
        this.utils._modifyObjKey(res, this.keyMap)
        this.imgList = res.imgList
        this.$emit('updatePagination', '', +res.page_count, +res.total_number)
      })
    },
    /**
     * 上传图片
     * @private
     */
    _uploadImg() {
      this._handleUpload('upload')
      if (this.isUpload) {
        this.formData.append('album_id', this.$route.query.id)
        this.formData.append('album_name', this.$route.params.name)
        this.formData.append('class_name', this.$route.query.className)
        this.api.uploadImgFormData(this.formData).then(() => {
          this.$notify({
            type: 'success',
            message: '上传成功~！🙂'
          })
          this._getPicList({
            curpage: this.currentNum,
            album_id: this.$route.query.id
          })
        })
      }
    },
    /**
     * 删除图片
     * @param albumId
     * @param picId
     * @param imgUrl
     * @param index
     */
    delPic(albumId, picId, imgUrl, index) {
      const data = {
        album_id: albumId,
        picture_id: picId,
        picture_url: imgUrl
      }
      this.api.pictureDel(data).then(res => {
        this.$notify({
          type: 'success',
          message: '删除成功~！🙂'
        })
        this.imgList.splice(index, 1)
        this.$parent.pagination.recordTotal =
          this.$parent.pagination.recordTotal - 1
        this.$parent.pagination.pageTotal = Math.ceil(
          this.$parent.pagination.recordTotal / 10
        )
      })
    },
    /**
     * 复制图片到就剪贴板
     */
    onCopy() {
      this.$notify({
        type: 'success',
        message: '复制成功啦~！😁'
      })
    },
    /**
     * 将图片上传到新品发布主图
     * @param item
     */
    mergePic(item) {
      const { imgUrl, picId, name, albumId } = item
      this.merge({
        url: imgUrl,
        picId,
        name,
        albumId,
        merge: 'picSpace'
      })
      this.$notify({
        message: '👌',
        type: 'success'
      })
    }
  }
}
</script>

<style lang="scss">
.album {
  .tips {
    padding: 1.2rem 0 1.2rem 3.2rem;
    color: colors('a4');
    display: flex;
    align-items: center;
    border-bottom: 1px dashed #e7e7e7;

    .icon-tixing {
      position: relative;
      display: inline-block;
      width: 1.5rem;
      height: 1.5rem;
      background-color: colors('bg-main');
      border-radius: 50%;
      margin-right: 0.7rem;

      &:before {
        @include transCenter(absolute, 50%, 50%);
      }
    }
  }

  .upload-img__album,
  .item {
    width: 12.5rem;
    height: 15rem;
    border-radius: 0.3rem;
    margin: 0 1.3rem 1.3rem 0;
    float: left;
  }

  .upload-img__album {
    height: 12.5rem;
    background-color: #f7f7f7;
  }

  .item {
    &:hover {
      .operator {
        opacity: 1;
        visibility: visible;
      }

      .img {
        box-shadow: 0 0.4rem 1.1rem 0 rgba(186, 186, 186, 0.75);
      }
    }
  }

  .img-list {
    @extend .clearfix;

    .icon-tupian {
      font-size: 3.7rem;
      color: #e7e7e7;
    }
  }

  .upload-img__album {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;

    p {
      margin-top: 0.3rem;
    }
  }

  .img-box {
    padding: 2.4rem 0 6.4rem 3.2rem;
  }

  .img {
    width: 12.5rem;
    height: 12.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #e7e7e7;
    transition: all 0.3s;
  }

  .name {
    margin-top: 1rem;
    @extend .ellipses;
  }

  .reference {
    position: absolute;
    top: 0.6rem;
    right: 0.6rem;
    width: 1.1rem;
    height: 1.1rem;
    background-color: #000000;
    opacity: 0.6;
    border-radius: 50%;
    color: #fff;
    font-size: 0.6rem;
    text-align: center;
  }

  .operator {
    position: absolute;
    bottom: 2rem;
    height: 1.9rem;
    line-height: 1.9rem;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s;

    i {
      font-size: 1.1rem;
    }

    .icon-shanchu,
    .icon-lianjie {
      color: #fff;
      float: left;
    }

    .icon-shangchuan1,
    .icon-xiazai {
      position: relative;
      top: 50%;
      transform: translateY(-50%);
      float: right;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 1.1rem;
      height: 1.1rem;
      background-color: #fff;
      border-radius: 50%;
      color: #000;
      font-size: 0.6rem;
    }

    .icon-xiazai {
      margin-right: 0.6rem;
    }

    .icon-shangchuan1 {
      margin-right: 0.4rem;

      &:before {
        margin-top: 3px;
      }
    }

    .icon-shanchu {
      margin-left: 0.6rem;
    }

    .icon-lianjie {
      margin-left: 0.4rem;
    }
  }
}
</style>
